import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import React from "react";

// ----------------------------------------------------------------------

export default function Select() {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreRoundedIcon,
      },

      styleOverrides: {
        root: {},
      },
    },
  };
}
